const Schedule = () => {
    return (
        <div className="schedule" id="schedule">
            <div className="title-desc">
                <div className="dash"></div>
                <h2>Schedule a Call With Us</h2>
            </div>
            <div className="iframe">
                <iframe
                className="hubspot"
                title="meeting-form"
                src="https://meetings.hubspot.com/adeshola-bello?embed=true"
                frameBorder={"0"}
                ></iframe>
            </div>
        </div>
    )
}

export default Schedule;